import type { PropsWithChildren } from 'react';

import { Box, Stack, Text, Title } from '@mantine/core';

import { Trans } from 'react-i18next';

import AssistantPageLayout from '../../features/bidResponse/components/assistant/components/AssistantPageLayout';
import { MessageInput } from '../../features/bidResponse/components/assistant/components/MessageInput';
import { useCreateThread } from '../../features/bidResponse/components/assistant/hooks/assistant.hook';
import AssistantLogo from '../../shared/assets/ai_icons/assistant_logo.svg?react';
import type { AssistantThreadFilters } from '../../shared/entities/AssistantThreadMessage';

export default function AssistantNewThreadPage() {
  const createThreadMutation = useCreateThread();

  const handleUserMessageSubmit = (
    messageContent: string,
    filters: AssistantThreadFilters,
  ) => {
    createThreadMutation.mutate({ messageContent, filters });
  };

  return (
    <AssistantPageLayout>
      <AssistantPageLayout.Title />

      <Stack align="center" mt="12" spacing="07">
        <Stack spacing="03" align="center">
          <AssistantLogo />
          <Title c="gray.9" order={2}>
            <Trans
              ns="bidResponse"
              i18nKey="assistant.howCanIHelp"
              components={{
                highlight: <SubtitleHighlight />,
              }}
            />
          </Title>
        </Stack>
        <Box
          bg="rgba(255, 255, 255, 0.50)"
          w="100%"
          maw="878px"
          p="05"
          sx={{
            borderRadius: 24,
            border: '2px solid #FFF',
          }}
        >
          <MessageInput
            onSubmit={handleUserMessageSubmit}
            isDisabled={createThreadMutation.isPending}
          />
        </Box>
      </Stack>
    </AssistantPageLayout>
  );
}

function SubtitleHighlight({ children }: PropsWithChildren) {
  return (
    <Text
      component="span"
      sx={{
        background:
          'linear-gradient(12deg, #1964E6 32%, #6B60E6 46%, #CC5DE8 59%)',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
      }}
    >
      {children}
    </Text>
  );
}
